<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.health'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('health')
    }
  },
  methods: {
    ...mapMutations([
      'selectHealthStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectHealthStatus(1);
      this.health = 1
    },
    chooseMedium: function () {
      this.selectHealthStatus(2);
      this.health = 2
    },
    chooseTop: function () {
      this.selectHealthStatus(3);
      this.health = 3
    }
  },
};
</script>

<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="health < 2"
        class="question_image question_image_health-basic d-block d-sm-none"
      ></div>
      <div v-else-if="health == 2"
        class="question_image question_image_health-medium d-block d-sm-none"
      ></div>
      <div v-else-if="health == 3"
        class="question_image question_image_health-top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title="questionAnswerData.answers.A"
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('health'); goToNextPage()"
      :imageName="questionAnswerData.images.Q10AA"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.B"
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('health'); goToNextPage()"
      :imageName="questionAnswerData.images.Q10AB"
    />
    <QuestionAnswer
      :title="questionAnswerData.answers.C"
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('health'); goToNextPage()"
      :imageName="questionAnswerData.images.Q10AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title="questionAnswerData.answers.A"
        :isSelected="health == 1"
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.B"
        :isSelected="health == 2"
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title="questionAnswerData.answers.C"
        :isSelected="health == 3"
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('health'); goToNextPage()">next</MDBBtn>
    </div>
  </QuestionPage>
</template>


